// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"style_buttonsContainer__vc-1F"};